import { Outlet, useLocation } from 'react-router-dom';
import { NavBar } from './NavBar';
import { OfflineBanner } from './OfflineBanner';

export function AppLayout() {
  // key на main + location.pathname → каждый переход роута вызывает
  // повторную mount-анимацию контейнера (мягкий fade/translate в Apple-стиле).
  const location = useLocation();
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <OfflineBanner />
      <NavBar />
      <main
        key={location.pathname}
        className="mx-auto w-full max-w-6xl flex-1 px-4 py-6 md:py-8 animate-enter"
      >
        <Outlet />
      </main>
    </div>
  );
}
